import { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import DashboardStyle from '../Dashboard/Dashboard'
import { customFuncsApi } from '../../api'
import { useSelector } from 'react-redux'
import numberWithSpaces from '../../lib/NumberWithSpaces'
import { Users } from 'lucide-react'
import UndiruvchiDashboardModal from '../../components/Modal/UndiruvchiDashboardModal'
import UndiruvchiDashboardListModal from '../../components/Modal/UndiruvchiDashboardModal/UndiruvchiDashboardListModal'

export default function UndiruvchiDashboard() {
	const { getMe } = useSelector((state) => state.main)
	const isBoshliqUndiruvchi = getMe?.Department2?.Name === 'Undiruvchi2'

	const [openUndiruvchiListModal, setOpenUndiruvchiListModal] = useState(false)
	const [openUndiruvchiDashboardModal, setOpenUndiruvchiDashboardModal] =
		useState(false)
	const [modalTitle, setModalTitle] = useState('')
	const [detailsEndpoint, setDetailsEndpoint] = useState('')
	const [totalEndpoint, setTotalEndpoint] = useState('')

	const [dashboardTotal, setDashboardTotal] = useState([
		{
			ClientCount: 0,
			PaidTotal: 0,
		},
	])

	const [dashboardAbove90, setDashboardAbove90] = useState([
		{
			ClientCount: 0,
			PaidTotal: 0,
		},
	])

	const [dashboardBetween80And90, setDashboardBetween80And90] = useState([
		{
			ClientCount: 0,
			PaidTotal: 0,
		},
	])

	const [dashboardBelow80, setDashboardBelow80] = useState([
		{
			ClientCount: 0,
			PaidTotal: 0,
		},
	])

	useEffect(() => {
		customFuncsApi
			.get(`xsSql/getDunnerDashboardTotal`, {
				params: {
					U_Dunner: isBoshliqUndiruvchi ? undefined : getMe.EmployeeID,
				},
			})
			.then((res) => {
				setDashboardTotal(res.data.value || [])
			})
			.catch(() => {
				alert('Ошибка при получении данных')
			})

		customFuncsApi
			.get(`xsSql/getDunnerDashboardAbove90`, {
				params: {
					U_Dunner: isBoshliqUndiruvchi ? undefined : getMe.EmployeeID,
				},
			})
			.then((res) => {
				setDashboardAbove90(res.data.value || [])
			})
			.catch(() => {
				alert('Ошибка при получении данных')
			})

		customFuncsApi
			.get(`xsSql/getDunnerDashboardBetween80n90`, {
				params: {
					U_Dunner: isBoshliqUndiruvchi ? undefined : getMe.EmployeeID,
				},
			})
			.then((res) => {
				setDashboardBetween80And90(res.data.value || [])
			})
			.catch(() => {
				alert('Ошибка при получении данных')
			})

		customFuncsApi
			.get(`xsSql/getDunnerDashboardBelow80`, {
				params: {
					U_Dunner: isBoshliqUndiruvchi ? undefined : getMe.EmployeeID,
				},
			})
			.then((res) => {
				setDashboardBelow80(res.data.value || [])
			})
			.catch(() => {
				alert('Ошибка при получении данных')
			})
	}, [])

	return (
		<>
			<Layout>
				<DashboardStyle>
					<div className="container">
						<div className="min-h-screen bg-white p-4">
							<div className="relative z-10 p-8">
								<div className="max-w-7xl mx-auto">
									<div className="text-center mb-12">
										<h1 className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-sky-600 bg-clip-text text-transparent mb-4">
											iComfort
										</h1>
										<p className="text-gray-600 text-lg">
											Аналитика по должникам и выплатам
										</p>
									</div>

									<div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
										{[
											{
												title: 'Общая информация',
												icon: <Users />,
												gradient: 'from-blue-400 to-sky-600',
												color: 'text-blue-600',
												data: dashboardTotal[0],
												detailsEndpoint: 'xsSql/getDashboardTotalDetails',
												totalEndpoint: 'xsSql/getDunnerDashboardTotal',
											},
											{
												title: 'Должники, которые заплатили более 90%',
												icon: <Users />,
												gradient: 'from-blue-400 to-sky-600',
												color: 'text-blue-600',
												data: dashboardAbove90[0],
												detailsEndpoint: 'xsSql/getDashboardAbove90Details',
												totalEndpoint: 'xsSql/getDunnerDashboardAbove90',
											},
											{
												title: 'Должники, которые заплатили от 80% до 90%',
												icon: <Users />,
												gradient: 'from-blue-400 to-sky-600',
												color: 'text-blue-600',
												data: dashboardBetween80And90[0],
												detailsEndpoint:
													'xsSql/getDashboardBetween80n90Details',
												totalEndpoint: 'xsSql/getDunnerDashboardBetween80n90',
											},
											{
												title: 'Должники, которые заплатили менее 80%',
												icon: <Users />,
												gradient: 'from-blue-400 to-sky-600',
												color: 'text-blue-600',
												data: dashboardBelow80[0],
												detailsEndpoint: 'xsSql/getDashboardBelow80Details',
												totalEndpoint: 'xsSql/getDunnerDashboardBelow80',
											},
										].map((card, index) => (
											<div
												key={index}
												className="group relative bg-white/70 backdrop-blur-lg rounded-3xl p-8 border border-gray-200/50 hover:border-blue-300/50 shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-105 cursor-pointer"
												onClick={() => {
													setModalTitle(card.title)
													setDetailsEndpoint(card.detailsEndpoint)
													setTotalEndpoint(card.totalEndpoint)
													if (isBoshliqUndiruvchi) {
														setOpenUndiruvchiListModal(true)
													} else {
														setOpenUndiruvchiDashboardModal(true)
													}
												}}
											>
												<div
													className={`absolute inset-0 bg-gradient-to-br ${card.gradient} opacity-0 group-hover:opacity-10 rounded-3xl transition-opacity duration-500`}
												></div>

												<div className="relative">
													<h3 className="text-xl font-bold text-gray-900 mb-6 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-sky-600 group-hover:to-blue-600 group-hover:bg-clip-text transition-all duration-300">
														{card.title}
													</h3>

													<div className="flex flex-col gap-4">
														<div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-100/50 group-hover:bg-white/90 transition-all duration-300">
															<h4 className="text-sm font-medium text-gray-700 mb-3">
																Должники
															</h4>
															<p className="text-3xl font-bold text-gray-900 group-hover:scale-105 transition-transform duration-300">
																{numberWithSpaces(card.data.ClientCount || 0)}
															</p>
														</div>

														<div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-100/50 group-hover:bg-white/90 transition-all duration-300">
															<h4 className="text-sm font-medium text-gray-700 mb-3">
																Общая сумма выплаченных денег
															</h4>
															<p
																className={`text-3xl font-bold ${card.color} group-hover:scale-105 transition-transform duration-300`}
															>
																${numberWithSpaces(card.data.PaidTotal || 0)}
															</p>
														</div>
													</div>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</DashboardStyle>
			</Layout>
			{openUndiruvchiDashboardModal && (
				<div className="z-40">
					<UndiruvchiDashboardModal
						isOpenModal={openUndiruvchiDashboardModal}
						setIsOpenModal={setOpenUndiruvchiDashboardModal}
						modalTitle={modalTitle}
						endpoint={detailsEndpoint}
					/>
				</div>
			)}
			{openUndiruvchiListModal && (
				<div className="z-50">
					<UndiruvchiDashboardListModal
						isOpenModal={openUndiruvchiListModal}
						setIsOpenModal={setOpenUndiruvchiListModal}
						totalEndpoint={totalEndpoint}
						openUndiruvchiModal={(U_Dunner) => {
							setDetailsEndpoint(
								(prev) => prev.split('?')[0] + `?U_Dunner=${U_Dunner}`,
							)
							setOpenUndiruvchiDashboardModal(true)
						}}
					/>
				</div>
			)}
		</>
	)
}
